import {Panorama} from 'mapy-cz';

let promise: Promise<typeof Panorama> | null = null;

export function loadMapyCz(): Promise<typeof Panorama> {
    promise = promise || new Promise<typeof Panorama>((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://api.mapy.cz/js/panorama/v1/panorama.js';
        script.async = true;
        script.onload = () => {
            resolve((window as any).Panorama);
        };
        script.onerror = () => {
            // Forget the failed attempt so that the next panorama tries to load the script again
            script.remove();
            promise = null;
            reject(new Error('Mapy.cz panorama script could not be loaded'));
        };
        document.body.appendChild(script);
    });

    return promise;
}
